import { useMemo } from 'react';
import { useAppSelector } from './redux';
import {
  buildSimulationTrackNodeViews,
  type SimulationTrackNodeView,
} from '../utils/simulationTrackNetworkView';

export function useSimulationTrackNodes(): SimulationTrackNodeView[] {
  const elements = useAppSelector((state) => state.layout.elements);

  return useMemo(
    () => buildSimulationTrackNodeViews(Object.values(elements)),
    [elements]
  );
}
